import { useState } from 'react';
import Item from './Item';
import './Section.css';

export default function Section({ section, onAddItem, onUpdateItem, onDeleteItem, onUpdateSection, onDeleteSection, isHost, user, userProfile, mode, participants }) {
    const [newItemName, setNewItemName] = useState('');
    const [isAdding, setIsAdding] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editTitle, setEditTitle] = useState(section.title);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newItemName.trim()) {
            onAddItem(newItemName);
            setNewItemName('');
            setIsAdding(false);
        }
    };

    const handleUpdateTitle = (e) => {
        e.preventDefault();
        if (editTitle.trim() && editTitle !== section.title) {
            onUpdateSection(editTitle);
        }
        setIsEditing(false);
    };

    return (
        <div className="section-card">
            <div className="section-header">
                {isEditing ? (
                    <form onSubmit={handleUpdateTitle} className="edit-title-form">
                        <input
                            type="text"
                            value={editTitle}
                            onChange={(e) => setEditTitle(e.target.value)}
                            autoFocus
                            className="edit-title-input"
                        />
                        <div className="edit-actions">
                            <button type="submit" className="save-mini-btn">Save</button>
                            <button type="button" onClick={() => setIsEditing(false)} className="cancel-mini-btn">Cancel</button>
                        </div>
                    </form>
                ) : (
                    <>
                        <h2 className="section-title">{section.title}</h2>
                        {isHost && (
                            <div className="section-meta-actions">
                                <button onClick={() => setIsEditing(true)} className="icon-btn" title="Edit Section Title">✏️</button>
                                <button onClick={() => setShowDeleteConfirm(true)} className="icon-btn delete" title="Delete Section">🗑️</button>
                            </div>
                        )}
                    </>
                )}
            </div>

            {showDeleteConfirm && (
                <div className="section-delete-confirm">
                    <p>⚠️ <strong>Wait!</strong> This will permanently delete <strong>"{section.title}"</strong> and all items inside it. Are you sure?</p>
                    <div className="section-delete-actions">
                        <button onClick={onDeleteSection} className="confirm-delete-btn-mini">Yes, Delete Everything</button>
                        <button onClick={() => setShowDeleteConfirm(false)} className="cancel-delete-btn-mini">No, Keep It</button>
                    </div>
                </div>
            )}

            <div className="items-list">
                {section.items.map(item => (
                    <Item
                        key={item.id}
                        item={item}
                        onUpdate={(updates) => onUpdateItem(item.id, updates)}
                        onDelete={() => onDeleteItem(item.id)}
                        isHost={isHost}
                        user={user}
                        mode={mode}
                        participants={participants}
                    />
                ))}
                {section.items.length === 0 && (
                    <div className="empty-state">No items yet. Add one needed!</div>
                )}
            </div>

            {/* Add Item: Hide if SIGNUP mode and not host */}
            {(mode !== 'SIGNUP' || isHost) && (
                isAdding ? (
                    <form onSubmit={handleSubmit} className="add-item-form">
                        <input
                            type="text"
                            placeholder="What needs to be brought?"
                            value={newItemName}
                            onChange={(e) => setNewItemName(e.target.value)}
                            autoFocus
                            onBlur={() => !newItemName && setIsAdding(false)}
                        />
                        <button type="submit" className="confirm-add-btn">Add</button>
                    </form>
                ) : (
                    <button
                        className="add-item-btn"
                        onClick={() => setIsAdding(true)}
                    >
                        + Add Item
                    </button>
                )
            )}
        </div>
    );
}
